export default __webpack_public_path__ + "static/media/proximanova-thin.645107fe.WOFF";